import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConclusionComponent } from 'app/main/pages/conclusion/conclusion.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-conclusion-modal',
  standalone: true,
  imports: [CommonModule, ConclusionComponent, TranslateModule],
  templateUrl: './conclusion-modal.component.html',
  styleUrls: ['./conclusion-modal.component.scss'],
})
export class ConclusionModalComponent {
  @Input() patientId: string;
  @Input() woundId: string;

  @ViewChild(ConclusionComponent) conclusionComponent: ConclusionComponent;

  constructor(public activeModal: NgbActiveModal) {}

  complete() {
    this.conclusionComponent.completeConclusion();
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
